// extracted by mini-css-extract-plugin
module.exports = {"xLanguageSwitcher__container":"style_xLanguageSwitcher__container__XY0yA","xLanguageSwitcher__select":"style_xLanguageSwitcher__select__zhl8f"};